import "./Home.scss";
import { Link } from "react-router-dom";
import BannerSlider from "./HomeBannerSlider";
import HomeContent1 from "./HomeContent1";
import HomeContent2 from "./HomeContent2";
import bc1 from "../assets/images/info1.png";
import bc2 from "../assets/images/info2.png";
import bc3 from "../assets/images/info3.png";
import { lowerCase } from "lodash";
import { useEffect } from "react";

function Home() {
  useEffect(() => {
    document.title = "INTER COMM";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const quickLinks = [
    "Acer",
    "Lenovo",
    "Asus",
    "MSI",
    "HP",
    "Dell",
    "Apple",
  ];

  const categories = [
    { label: "Laptop & Tablet", slug: "laptop" },
    { label: "Desktop & Monitor", slug: "desktop" },
    { label: "PC Components", slug: "pccomponents" },
    { label: "Data Management System", slug: "dms" },
    { label: "Wearables", slug: "wearables" },
    { label: "Networking", slug: "networking" },
    { label: "Printer", slug: "printer" },
    { label: "Home Appliance", slug: "homeappliance" }
  ];

  const brands = ["Acer", "Lenovo", "Asus", "MSI", "HP", "Dell", "Apple"];

  const bottomCategories = [
    {
      img: bc1,
      title: "100% Genuine",
      desc: "Genuine product with warranty.",
    },
    {
      img: bc2,
      title: "Fast Delivery",
      desc: "Free shipping over RM2000!",
    },
    {
      img: bc3,
      title: "Instant response",
      desc: "24-hours support",
    },
  ];

  return (
    <div className="home">
      <section className="home-topbar">
        <div className="container">
          <div className="topbar-inner">
            <div className="topbar-left">
              <span>Welcome to Inter Comm Trading</span>
            </div>

            <div className="topbar-right">
              <a href="#">Hotline: 011-12063712</a>
              {/* <a href="#featured-products">Featured Products</a>
              <a href="#main-categories">Categories</a>
              <a href="#contact-us">Contact</a> */}
            </div>
          </div>
        </div>
      </section>

      <section className="home-navband">
        <div className="container">
          <div className="navband-inner">
            <div className="brand-block">
              <span className="brand-kicker">STOREFRONT</span>
              <h1>INTER COMM TRADING</h1>
              {/* <p>NBPlaza-style commercial homepage layout</p> */}
            </div>

            <div className="quick-links">
              {quickLinks.map((item) => (
                <a key={item} href={`#featured-products-` + lowerCase(item)} className="quick-link-pill">
                  {item}
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="home-hero-layout">
        <div className="container">
          <div className="hero-grid">
            <aside className="category-sidebar" id="main-categories">
              <div className="sidebar-title">All Categories</div>

              <ul className="category-list">
                {categories.map((item) => (
                  <li key={item.slug}>
                    <Link to={`/category/${item.slug}`}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </aside>

            <div className="hero-main">
              <BannerSlider />
            </div>
          </div>
        </div>
      </section>

      <section className="home-usp-strip">
        <div className="container">
          <div className="usp-grid">
            <div className="usp-card">
              <h3>Wide Product Selection</h3>
              <p>From entry-level laptops to high-performance gaming machines.</p>
            </div>
            <div className="usp-card">
              <h3>Competitive Pricing</h3>
              <p>Affordable deals across top brands and accessories.</p>
            </div>
            <div className="usp-card">
              <h3>Fast Support</h3>
              <p>Quick response for product enquiries and purchase assistance.</p>
            </div>
          </div>
        </div>
      </section>

      <HomeContent1 />
      <HomeContent2 />

      <section className="home-brand-strip">
        <div className="container">
          {/* <div className="brand-strip-grid">
            <div className="brand-strip-card">
              <span className="strip-label">SHOWCASE</span>
              <h3>Modern catalog homepage</h3>
              <p>Designed to feel cleaner, more premium, and more structured.</p>
            </div>

            <div className="brand-logo-list">
              {brands.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
          </div> */}

          <div className="bottom-category-grid">
            {bottomCategories.map((item) => (
              <a key={item.title} href="#" className="bottom-category-card">
                <img src={item.img} alt={item.title} className="bottom-category-card-img"/>
                <span>{item.title}</span>
                <label>{item.desc}</label>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="home-contact-cta" id="contact-us">
        <div className="container">
          <div className="contact-cta-inner">
            <div className="contact-copy">
              <span className="section-kicker">ABOUT US</span>
              <h2>INTER COMM TRADING SDN BHD</h2>
              <p>
                35-1, Jalan KLJ 5, Taman Kota Laksamana Jaya, 75200 Melaka, Malaysia
              </p>
            </div>

            <div className="contact-actions">
              <a href="https://wa.me/601112063712" className="primary-btn" target="_blank" rel="noopener noreferrer">
                Contact Us
              </a>
              <button
                type="button"
                className="secondary-btn"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                Back to Top
              </button>
            </div>
          </div>
          <div className="contact-cta-inner-reserved">
            <span>Copyright © 2026 Inter Comm E-Store. All rights reserved.</span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;